import { Box, Modal } from "@mui/material";
import React from "react";
import FormReception from "./formReception";

export default function EditReceptionModal({
  open,
  setOpen,
  data,
  dataArea,
  setDataPatients,
}) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "550px",
    height: "470px",
    padding: "22px 23px",
    borderRadius: "13px",
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: "40px",
  };
  // console.log(data);

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <FormReception
          setDataPatients={setDataPatients}
          DATA={data}
          //   ageType={ageType}
          dataArea={dataArea}
          handleClose={() => {
            setOpen(false);
          }}
          edit
          //   mode={selectedMode}
          //   setLevelPop={setLevelPop}
          //   setSelectedLevel={setSelectedLevel}
        />
      </Box>
    </Modal>
  );
}
